import React, { Component } from "react";
import Signbutton from "../forms/button";
import { Input } from "../forms/input";
import { QueryAssistant } from "../home/home";
import Appbar from "./appbar";
import DemoCarousel from "./carsouel";
import { Checkbox } from "@material-ui/core";

import {
  getCamsData,
  generateEmpanelOTP,
  validateEmpanelOTP,
  removeData,
  saveEmpanelData,
  validateArn,
  saveCamsData,
} from "../../store/actions/empanelment";
import { connect } from "react-redux";
import CustomLoader from "../forms/Loader";
import { resetIdCounter } from "downshift";

class DistributorEmpanellement extends Component {
  constructor(props) {
    super(props);
    this.state = {
      terms: true,
      arnCode: { value: "" },
      pan: { value: "" },
      email: { value: "" },
      mobile: { value: "" },
      otp: { value: "" },
      display: false,
      status: false,
    };
  }
  async componentDidMount() {
    await this.props.removeData();
  }
  // validateARNCode = async () => {
  //   if (!!this.state.arnCode.value) {
  //     const response = await this.props.validateArn({
  //       Arncode: "ARN-" + this.state.arnCode.value,
  //     });
  //     if (response.Dtinformation.length > 0) {
  //       const data = response.Dtinformation[0];
  //       if (data.Return_Message !== "Success") {
  //         alert(`${data.Return_Message}`);
  //         this.setState({
  //           arnCode: { value: "", isError: false },
  //         });
  //       }
  //     } else {
  //       alert("Invalid ARN Code");
  //       this.setState({
  //         arnCode: { value: "", isError: false },
  //       });
  //       this.arnCodeField.focus();
  //     }
  //   }
  // };
  changeValue = (label) => (event) => {
    if (label === "arnCode" && event.target.value.length < 30) {
      this.setState({
        [label]: { value: event.target.value },
      });
    } else if (label === "mobile" && event.target.value.length < 11) {
      this.setState({
        [label]: { value: event.target.value },
      });
    } else if (label === "email") {
      this.setState({
        [label]: { value: event.target.value },
      });
    } else if (label === "pan") {
      const panValue = event.target.value;
      this.setState({
        [label]: { value: panValue.toUpperCase() },
      });
    } else {
      this.setState({
        [label]: { value: event.target.value },
      });
    }
  };

  toggleCheckbox = () => {
    this.setState({ terms: !this.state.terms });
  };

  showError = (label) => (event) => {
    if (label === "pan") {
      if (
        !!event.target.value &&
        /[A-Za-z]{5}\d{4}[A-Za-z]{1}/.test(event.target.value) === false
      ) {
        this.setState({
          [label]: {
            value: "",
            isError: true,
            errorMessage: "Please enter valid PAN number",
          },
        });
      }
    } else if (label === "email") {
      if (
        !!event.target.value &&
        !/^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/.test(
          event.target.value
        )
      ) {
        this.setState({
          [label]: {
            value: "",
            isError: true,
            errorMessage: "Please enter valid Email ID",
          },
        });
      }
    } else if (label === "mobile") {
      if (
        !!event.target.value &&
        !/^(?:(?:\+|0{0,2})91(\s*[\-]\s*)?|[0]?)?[6-9]\d{9}$/.test(
          this.state.mobile.value
        )
      ) {
        this.setState({
          [label]: {
            value: "",
            isError: true,
            errorMessage: "Please enter valid Mobile number",
          },
        });
      }
    }
  };

  submit = async () => {
    const { terms, otp, display, status, ...others } = this.state;
    const keys = Object.keys(others);
    const findError = keys.every((key) => !!others[key].value);
    if (!findError) {
      keys.forEach((key) => {
        !others[key].value &&
          this.setState({
            [key]: {
              ...others[key],
              isError: true,
              errorMessage: `${
                key === "arnCode"
                  ? "ARN code"
                  : key === "pan"
                  ? "PAN number"
                  : key === "email"
                  ? "Email ID"
                  : key === "mobile"
                  ? "Mobile number"
                  : ""
              } is mandatory`,
            },
          });
      });
      const firstErroredKey = keys.find((key) => !others[key].value);
      switch (firstErroredKey) {
        case "arnCode": {
          this.arnCodeField.focus();
          break;
        }
        case "pan": {
          this.panField.focus();
          break;
        }
        case "email": {
          this.emailField.focus();
          break;
        }
        case "mobile": {
          this.mobileField.focus();
          break;
        }
        default:
          break;
      }
    } else {
      this.setState({
        display: true,
      });
      const details = {
        arnCode: "ARN-" + this.state.arnCode.value,
        pan: this.state.pan.value,
        email: this.state.email.value,
        mobile: this.state.mobile.value,
      };
      this.linkClicked();
      await this.props.saveEmpanelData(details);
      // await this.validateOtp();
      this.setState({
        display: false,
      });
      this.props.history.push("/distributor-empanellement/bank-details");
      // if (this.state.status === true) {
      //   this.props.history.push(
      //     "/distributor-empanellement/bank-details"
      //   );
      // } else {
      //   alert("Invalid OTP");
      // }
    }
  };
  validateOtp = async () => {
    const otpValParams = {
      otp: this.state.otp.value,
      arncode: this.state.arnCode.value,
    };
    const otpvalResponse = await this.props.validateEmpanelOTP(otpValParams);
    const data = otpvalResponse.Dtinformation[0];
    if (data.Result !== "INAVLID OTP") {
      this.setState({
        status: true,
      });
    } else {
      this.setState({
        otp: {
          value: this.state.otp.value,
          isError: true,
          errorMessage: "Invalid OTP",
        },
        status: false,
      });
    }
  };

  linkClicked = async () => {
    const { arnCode, pan, email, mobile } = this.state;
    const CheckEveryField =
      !!arnCode.value && !!pan.value && !!email.value && !!mobile.value;
    if (!CheckEveryField) {
      alert("All fields are mandatory");
    } else {
      this.setState({
        display: true,
      });
      const data = await fetch(
        "https://clientwebsitesuat3.kfintech.com/bajaj/api/v1/cams/validate",
        {
          method: "POST",
          body: JSON.stringify({
            Arn: "ARN-" + this.state.arnCode.value,
            Pan: this.state.pan.value,
            Email: this.state.email.value,
            Mobile: this.state.mobile.value,
          }),
          headers: {
            "Content-type": "application/json; charset=UTF-8",
          },
        }
      );
      const res = await data.json();
      console.log(res.data);
      await this.props.saveCamsData(res.data);
      // const camsParams = {
      //   ARNcode: "ARN-" + this.state.arnCode.value,
      //   PAN: this.state.pan.value,
      //   Email: this.state.email.value,
      //   MobileNo: this.state.mobile.value,
      // };

      // const CAMSData = await this.props.getCamsData(camsParams);
      // const { DtData } = CAMSData;
      // if (
      //   DtData[0].RETURN_MESSAGE === "No records available for the given inputs"
      // ) {
      //   this.setState({
      //     arnCode: { value: "" },
      //     pan: { value: "" },
      //     email: { value: "" },
      //     mobile: { value: "" },
      //     otp: { value: "" },
      //     status: { value: false },
      //   });
      //   alert(
      //     "No records available with AMFI/KYD for the given ARN Number, Kindly provide Valid ARN to proceed further"
      //   );
      // } else {
      //   const otpGenParams = {
      //     arncode: this.state.arnCode.value,
      //     mobile: this.state.mobile.value,
      //     email: this.state.email.value,
      //     fund: "189",
      //   };

      //   await this.props.generateEmpanelOTP(otpGenParams);
      //   alert(
      //     "One Time Password(OTP) has been sent to your registered Mobile and Email"
      //   );
      // }
      this.setState({
        display: false,
      });
    }
  };

  render() {
    const { terms, arnCode, pan, email, mobile, otp } = this.state;
    return (
      <div className="login-container">
        <CustomLoader display={!!this.state.display} />
        {/* <QueryAssistant /> */}
        <Appbar />
        <div className="login-without-appbar">
          <DemoCarousel empanellement={true} />
          <div className="login-right-div" style={{ overflow: "scroll" }}>
            <div>
              <div className="login-title">New partner empanelment</div>

              <div className="input-margin">
                <Input
                  maxLength={50}
                  name="ARN*"
                  image={"/images/id-card.svg"}
                  value={arnCode.value}
                  onChange={this.changeValue("arnCode")}
                  onKeyDown={(evt) =>
                    (evt.key === "e" || evt.key === "." || evt.key === "-") &&
                    evt.preventDefault()
                  }
                  type="number"
                  // onBlur={this.validateARNCode}
                  isShowError={arnCode.isError}
                  errorMessage={arnCode.errorMessage}
                  inputref={(ele) => (this.arnCodeField = ele)}
                />
              </div>

              <div className="input-margin">
                <Input
                  maxLength={50}
                  name="PAN*"
                  image={"/images/id-card.svg"}
                  onChange={this.changeValue("pan")}
                  onBlur={this.showError("pan")}
                  inputref={(ele) => (this.panField = ele)}
                  value={pan.value}
                  bordercolor="#a6a6a6"
                  isShowError={pan.isError}
                  errorMessage={pan.errorMessage}
                  placeholder={"Please enter your PAN"}
                />
              </div>

              <div className="input-margin">
                <Input
                  maxLength={50}
                  name="Email ID*"
                  image={"/images/id-card.svg"}
                  onChange={this.changeValue("email")}
                  inputref={(ele) => (this.emailField = ele)}
                  value={email.value}
                  bordercolor="#a6a6a6"
                  onBlur={this.showError("email")}
                  isShowError={email.isError}
                  errorMessage={email.errorMessage}
                  placeholder={"Please enter your email ID"}
                />
              </div>

              <div className="input-margin">
                <Input
                  maxLength={50}
                  name="Mobile*"
                  onChange={this.changeValue("mobile")}
                  inputref={(ele) => (this.mobileField = ele)}
                  onKeyDown={(evt) =>
                    (evt.key === "e" || evt.key === "." || evt.key === "-") &&
                    evt.preventDefault()
                  }
                  image={"/images/id-card.svg"}
                  type="number"
                  value={mobile.value}
                  bordercolor="#a6a6a6"
                  onBlur={this.showError("mobile")}
                  isShowError={mobile.isError}
                  errorMessage={mobile.errorMessage}
                  placeholder={"Please enter your mobile number"}
                />
              </div>
              <div className="input-margin">
                <Input
                  maxLength={50}
                  name="OTP*"
                  link={true}
                  linkText={"Click here to generate OTP"}
                  linkClicked={this.linkClicked}
                  onChange={this.changeValue("otp")}
                  onKeyDown={(evt) =>
                    (evt.key === "e" || evt.key === "." || evt.key === "-") &&
                    evt.preventDefault()
                  }
                  type="number"
                  inputref={(ele) => (this.otpField = ele)}
                  value={otp.value}
                  bordercolor="#a6a6a6"
                  isShowError={otp.isError}
                  isError={otp.isError}
                  errorMessage={otp.errorMessage}
                  placeholder={"Please enter your OTP"}
                />
              </div>
              <div className="input-margin" style={{ fontStyle: "Italic" }}>
                *Same as AMFI/CDMS/KYD database
              </div>
              <div className="input-margin">
                *By submitting this, I agree to the relevant
                <span
                  target="_blank"
                  // onClick={() => {
                  //   window.open("https://t.me/+W7Ed6Ihx-dthMjk1");
                  // }}
                  className="terms_conditions"
                >
                  Terms and Conditions
                </span>{" "}
                before proceeding.
              </div>
              {/* <div
                className="login-terms-conditions"
                style={{
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <Checkbox
                  onClick={this.toggleCheckbox}
                  // value={combo.label}
                  checked={terms}
                  color="secondary"
                />
                <div className="login-term-text">
                  I have understood and agree to your{" "}
                  <a href={ "/terms-conditions"} target="_blank">
                    Terms and Conditions*
                  </a>
                </div>
              </div> */}

              <Signbutton buttontitle="Submit" onClick={this.submit} />
              <span
                className="login-no-account-span mouse-pointer"
                onClick={() => this.props.history.push("/login")}
              >
                Back to Login Page
              </span>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
export default connect(null, {
  getCamsData,
  generateEmpanelOTP,
  validateEmpanelOTP,
  removeData,
  saveEmpanelData,
  validateArn,
  saveCamsData,
})(DistributorEmpanellement);
